import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { login, isLoggedIn } from '../../services/auth';
import api from '../../services/api';
// Active login UI: switch versions by changing import (v2 vs v3)
// import LoginLayout from './v2/LoginLayout';
import LoginLayout from './v3/LoginLayout';

/** Safe internal path for react-router navigate (no protocol, no scheme-relative URLs). */
function safeRedirectTarget(raw) {
  if (!raw || typeof raw !== 'string') return null;
  let decoded;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return null;
  }
  if (!decoded.startsWith('/') || decoded.startsWith('//')) return null;
  return decoded;
}

export default function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn()) {
      const next = safeRedirectTarget(searchParams.get('redirect')) || '/dashboard';
      navigate(next, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleChange(field, value) {
    if (field === 'username') setUsername(value);
    if (field === 'password') setPassword(value);
    if (field === 'remember') setRemember(value);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password, remember);
      const next = safeRedirectTarget(searchParams.get('redirect')) || '/dashboard';
      navigate(next, { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Check credentials.');
    } finally {
      setLoading(false);
    }
  }

  async function handleGoogleLogin(credential) {
    // Throws on failure so LoginLayout can show the error next to the button
    const { data } = await api.post('/auth/google/login', { credential });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    const next = safeRedirectTarget(searchParams.get('redirect')) || '/dashboard';
    navigate(next, { replace: true });
  }

  const trackCust = searchParams.get('cust') || '';
  const trackCode = searchParams.get('code') || '';
  const fromTrack = searchParams.get('ref') === 'track';
  const trackBack = fromTrack && (trackCust || trackCode)
    ? `/track?${new URLSearchParams({ cust: trackCust, code: trackCode }).toString()}`
    : fromTrack ? '/track' : null;

  return (
    <LoginLayout
      username={username}
      password={password}
      remember={remember}
      error={error}
      loading={loading}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onGoogleLogin={handleGoogleLogin}
      onForgotPassword={() => navigate('/forgot-password')}
      trackBack={trackBack}
    />
  );
}
